// extracted by mini-css-extract-plugin
export default {"policy":"FacilityInfo_policy__P-5Kz","editLink":"FacilityInfo_editLink__3PCk4","active":"FacilityInfo_active__gHPIK","inactive":"FacilityInfo_inactive__DP19d"};